import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Config from "config";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import {
  setSortFieldParticipation,
  setOrderParticipation,
  setCurrentPageParticipation,
  setValueParticipation,
} from "../../store/actions";

//import components
import ReactPaginate from "react-paginate";
//redux

import { useSelector, useDispatch } from "react-redux";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "../Investor/useDebounce";
import { useNavigate } from "react-router-dom";

function ParticipationList() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [participationData, setParticipationData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const [redirectToLoginPage, setRedirect] = useState(false);
  const [wait, setWait] = useState(400);

  // Pagination

  const currentPage = useSelector(
    (state) => state.FiltreParticipations.currentPage
  );
  const itemsPerPage = 20; // Limite d`affichage par page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentItems = participationData.slice(indexOfFirstItem, indexOfLastItem);
  //Recherche
  const value = useSelector((state) => state.FiltreParticipations.value);

  const debounceSearch = useDebounce(value, 500);
  // Triage
  const handleSorting = async (sortField, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/mes_participations?page=${currentPage}&sort_by=${sortField}_${sortOrder}&key=${value}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      const upData = newData;
      setParticipationData(upData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };
  //Thead
  const sortField = useSelector(
    (state) => state.FiltreParticipations.sortField
  );
  const order = useSelector((state) => state.FiltreParticipations.order);
  const [isSorting, setIsSorting] = useState(false);
  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageParticipation(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";

    dispatch(setSortFieldParticipation(accessor));
    dispatch(setOrderParticipation(sortOrder));

    handleSorting(accessor, sortOrder); // Appel à la fonction de tri
    setIsSorting(false);
  };

  //meta title
  document.title = "Mes participations | DOM COM";

  useEffect(() => {
    if (redirectToLoginPage == true) {
      localStorage.removeItem("auth_token_" + api);
      localStorage.removeItem("authUser_" + api);
      localStorage.removeItem("sideBar_" + api);
      navigate(`${backUrl}/login`);
      window.location.reload(false);
    }
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, [redirectToLoginPage, navigate]);
  //page change
  const fetchPage = async (currentPage) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/mes_participations?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let currentPage = data.selected + 1;
    const getData = await fetchPage(currentPage);
    dispatch(setCurrentPageParticipation(currentPage));
    setParticipationData(getData);
  };
  // Filtre

  // Mettre à jour les paramètres de filtre et déclencher la fonction de filtrage avec débordement

  // Fonction pour mettre à jour l'état du filtre et appeler la mise à jour des paramètres accumulés
  const handleFilterChange = (accessor, value) => {
    const updatedFilters = participationData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return {
          ...filter,
          value: value,
        };
      }
      return filter;
    });

    setParticipationData((prevData) => ({
      ...prevData,
      filters: updatedFilters,
    }));

    // Mettre à jour les paramètres de filtre
  };

  // La fonction de filtrage reste inchangée, elle utilise les paramètres de filtre accumulés
  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/mes_participations?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      // if (!response.ok) {
      //   redirectToLoginPage = true;

      //   throw new Error("La réponse du réseau n'est pas valide");
      // }

      const newData = await response.json();
      setParticipationData(newData);
      // console.log(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    return (
      <>
        {!loading ? (
          <>
            {participationData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueParticipation(e.target.value));
                          dispatch(setCurrentPageParticipation(1));
                          handleFilterChange(filter.accessor, value);
                        }}
                      />
                    </Col>
                  );
                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/mes_participations?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n'est pas valide");
        // }

        const newData = await response.json();
        setParticipationData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    handleFiltering();
  }, []);

  useEffect(() => {
    const handleFiltering = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/mes_participations?page=${currentPage}&sort_by=${sortField}_${order}&key=${value}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) {
          navigate(`${backUrl}/forbidden`);
        }
        if (response.status === 500) {
          navigate(`${backUrl}/error`);
        }
        if (response.status === 203) {
          navigate(`${backUrl}/error404`);
        }
        // if (!response.ok) {
        //   setRedirect(true);
        //   throw new Error("La réponse du réseau n`est pas valide");
        // }
        dispatch(setCurrentPageParticipation(1));
        const newData = await response.json();
        setParticipationData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };

    if (currentPage === 1) {
      handleFiltering();
    }
  }, [debounceSearch]);

  return (
    <React.Fragment>
      {/* <DeleteModal
       show={deleteModal}
       onDeleteClick={}
       onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Mes participations (
                      {loading ? "--" : participationData?.total_records})
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      &nbsp; &nbsp;
                      {/* {/* <Link to="#!" className="btn btn-sm btn-light me-1">
                        <i className="mdi mdi-export-variant"></i>Exporter
                      </Link> */}
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {participationData?.headers?.map(
                                ({ label, accessor, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessor ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessor}
                                      onClick={
                                        sortable
                                          ? () => handleSortingChange(accessor)
                                          : null
                                      }
                                      className="text-nowrap"
                                      style={{
                                        cursor: sortable
                                          ? "pointer"
                                          : "default",
                                      }}
                                    >
                                      {label}
                                      {cl}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {participationData?.data?.map(
                              (rowData, rowIndex) => (
                                <tr key={rowIndex}>
                                  {participationData?.headers?.map(
                                    ({ label, accessor }) => (
                                      <>
                                        {label === "PME" ? (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            <Link
                                              to={`${backUrl}/pmes/${rowData.pme_id}`}
                                              className="underline"
                                            >
                                              {rowData[accessor] || "——"}
                                            </Link>{" "}
                                          </td>
                                        ) : typeof rowData[accessor] ===
                                          "number" ? (
                                          <td
                                            className={"text-end"}
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            {rowData[accessor].toLocaleString(
                                              "fr-FR",
                                              {
                                                style: "currency",
                                                currency: "EUR",
                                              }
                                            ) || "——"}
                                          </td>
                                        ) : label === "% de détention" ? (
                                          <td
                                            className={"text-end"}
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            {parseFloat(
                                              rowData[accessor]
                                            ).toFixed(2) + " %" || "——"}
                                          </td>
                                        ) : (
                                          <td
                                            style={{
                                              // width: "33.33%",
                                              padding: "12px",
                                              fontFamily: "Sans-Serif",
                                            }}
                                            key={`${rowIndex}-${accessor}`}
                                          >
                                            {rowData[accessor] || "——"}
                                          </td>
                                        )}
                                      </>
                                    )
                                  )}
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={wait} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={participationData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
}

export default ParticipationList;
